import clsx from "clsx";
import * as React from "react";

export interface SkeletonLoadingProps {
    component?: any;
    className?: string;
    animation?: "pulse" | "wave";
    width?: string;
    height?: string;
    style?: React.CSSProperties;
}

const SkeletonLoading: React.FC<SkeletonLoadingProps> = ({
    component: Component = "div",
    className = "",
    animation = "pulse",
    style,
    width,
    height,
}) => {
    let styles: React.CSSProperties = {};

    if (style) {
        styles = style;
    }

    if (width) {
        styles.width = width;
    }
    if (height) {
        styles.height = height;
    }

    return (
        <Component
            className={clsx("tmp-skeleton-loading", className, {
                "tmp-skeleton-loading-pulse": animation === "pulse",
                "tmp-skeleton-loading-wave": animation === "wave",
            })}
            style={styles}
        />
    );
};

export default SkeletonLoading;
